module.exports = __webpack_public_path__ + "img/mcn网红电商.72598931.png";